import React from "react";
import Dashboard from "../pages/Dashboard";
import Preference from "./Preference";
import SearchBox from "./SearchBox";

const NoContent = ({ outletTitle }) => {
  return (
    <Dashboard>
      <div className="outlet">
        <div className="home-top">
          <SearchBox />
          <Preference />
        </div>
        <h2 className="outlet-title">{outletTitle}</h2>
        <p className="no-content">No content in this section</p>
      </div>
    </Dashboard>
  );
};

export default NoContent;
